// <socks-addon> (§7.3): casilla «¿También resbala…?» nunca marcada. Al marcarla aparece el texto, el enlace y
// un selector de talla; no se añade nada hasta pulsar el botón (Ajax Cart API, cart-store.js).
// Guarda el atributo oculto del carrito _resbala=si (vacío al desmarcarla, que lo borra) con /cart/update.js.
import { addItems, setAttribute } from './cart-store.js';

class SocksAddon extends HTMLElement {
  connectedCallback() {
    this.data = JSON.parse(this.querySelector('[data-socks-json]').textContent);
    this.toggle = this.querySelector('[data-addon-toggle]');
    this.panel = this.querySelector('.addon__panel');
    this.status = this.querySelector('.addon__status');
    this.busy = false;
    this.attributeSaved = Promise.resolve();
    this.toggle.checked = false;
    this.toggle.addEventListener('change', () => this.onToggle());
    this.querySelector('[data-addon-add]').addEventListener('click', () => this.add());
  }

  onToggle() {
    const on = this.toggle.checked;
    this.panel.hidden = !on;
    this.toggle.setAttribute('aria-expanded', String(on));
    // Si falla la red no pasa nada: el atributo solo sirve para la sugerencia del carrito.
    // Se guarda la promesa para no mandar a la vez /cart/update.js y /cart/add.js (el carrito no los ordena).
    this.attributeSaved = setAttribute('_resbala', on ? 'si' : '').catch(() => {});
    if (on) window.Shopify?.analytics?.publish?.('pawly:add_on_socks_shown', {});
  }

  async add() {
    const chosen = this.querySelector('input[name="addon-size"]:checked');
    const variant = this.data.variants.find((v) => String(v.id) === chosen?.value);
    if (!variant) {
      this.status.textContent = this.data.strings.chooseSize;
      this.querySelector('input[name="addon-size"]')?.focus();
      return;
    }
    if (this.busy) return;
    this.busy = true;
    this.status.textContent = '';
    try {
      await this.attributeSaved;
      await addItems([{ id: variant.id, quantity: 1 }]);
    } catch (error) {
      this.status.textContent = error.status === 422 ? this.data.strings.outOfStock : this.data.strings.networkError;
      return;
    } finally {
      this.busy = false;
    }
    // «Añadido: {{ title }}» con «{{ title }}, talla {{ size }}» (products.added y products.addon_added_title).
    const line = this.data.strings.addedTitle.replace('{{ title }}', () => this.data.title.split(' (')[0]).replace('{{ size }}', () => variant.title);
    this.status.textContent = this.data.strings.added.replace('{{ title }}', () => line);
    window.Shopify?.analytics?.publish?.('pawly:add_on_socks', { variant_id: variant.id, price: variant.price });
  }
}

customElements.define('socks-addon', SocksAddon);
